import React from 'react'

interface GMProps {
  width: number
  height: number
  position?: any | undefined
  color?: string
  color2?: string
}

export const SVG_WIREFRAME_WIDTH = 261
export const SVG_WIREFRAME_HEIGHT = 176.1

export default function GiftMachineWireFrame(props: GMProps) {
  return (
    <svg
      version="1.1"
      id="Calque_1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 261 176.1"
      xmlSpace="preserve"
      style={{
        height: props.height,
        width: props.width,
        position: props.position,
      }}
    >
      <style type="text/css">
        {`
          .st0{fill:${props.color};}
          .st1{fill:${props.color2 || '#1D1D1B'};}
        `}
      </style>
      <g id="Groupe_1658" transform="translate(0 0)">
        <g id="Groupe_1653" transform="translate(0 0)">
          <g>
            <g id="Groupe_1652">
              <path
                id="Ligne_69"
                className="st0"
                d="M39.5,91.5H4.6c-1.1,0-2-0.9-2-2s0.9-2,2-2h34.9c1.1,0,2,0.9,2,2S40.6,91.5,39.5,91.5z"
              />
              <path
                id="Tracé_1397"
                className="st0"
                d="M252.5,91.5h-34.9c-1.1,0-2-0.9-2-2s0.9-2,2-2h34.9c1.1,0,2,0.9,2,2
					S253.6,91.5,252.5,91.5z"
              />
            </g>
          </g>
        </g>
        <path
          id="Tracé_1398"
          className="st1"
          d="M0,167.3c87,0,174,0,261,0c0,2.9,0,5.8,0,8.7c-87,0-173.9,0.1-260.9,0.1
		C0,173.2,0,170.3,0,167.3z"
        />
        <path
          id="Tracé_1398_00000170982864782505819120000009628893084743374000_"
          className="st1"
          d="M0,0c87,0,174,0,261,0
		c0,2.9,0,5.8,0,8.7C174,8.8,87,8.8,0.1,8.8C0,5.9,0,2.9,0,0z"
        />
      </g>
      <g>
        <g>
          <path
            id="Tracé_1391"
            className="st0"
            d="M8.3,88.9c0,25,2.8,44.4,3.8,50.7c2.3,14.5,5.3,26.8,8,36.5c-6.7,0-13.5,0-20.2,0
			C0,117.4,0,58.7,0,0c6.7,0,13.5,0,20.2,0C10.4,37.3,8.4,68.2,8.3,88.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            id="Tracé_1391_00000008850115750279510780000016761721593173876616_"
            className="st0"
            d="M252.7,88.9c0,25-2.8,44.4-3.8,50.7
			c-2.3,14.5-5.3,26.8-8,36.5c6.7,0,13.5,0,20.2,0c0-58.7,0-117.4,0-176.2c-6.7,0-13.5,0-20.2,0C250.6,37.3,252.6,68.2,252.7,88.9z"
          />
        </g>
      </g>
    </svg>
  )
}
